import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PlayerClassSelectorComponent } from 'src/app/components/player-class-selector/player-class-selector.component';
import { DataStoreService, loot_pools } from 'src/app/data-store.service';
import { AttributeStore, InventoryItem, Monster, Player } from 'src/app/models/models';

@Component({
  selector: 'app-play-through',
  templateUrl: './play-through.component.html',
  styleUrls: ['./play-through.component.scss']
})
export class PlayThroughComponent implements OnInit {

  compressed_row = false;

  inventory: Record<string, InventoryItem> = {};

  accordian: Record<string, boolean> = {}

  dive: { player: Player, expanded: boolean }[] = [];

  Start() {

  }

  toogle_compressed_row() {
    this.compressed_row = !this.compressed_row;
  }

  Clear() {
    this.dive = [];
    this.store.current_players = [];
  }

  AddToDive(player: Player) {
    if (this.dive.find(x => x.player === player) == null) {
      this.dive.push({ player, expanded: false });
      this.store.current_players.push(player.name);
    }
  }

  Death(player: Player) {
    player.health = 0;
    player.energy = 0;
    player.exp = 0;
    //this.store.players = this.store.players.filter(x => x != player);
    this.dive = this.dive.filter(x => x.player != player);
  }

  toogle(player: Player) {
    this.accordian[player.name] = !this.accordian[player.name];
  }

  constructor(public store: DataStoreService, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.inventory = this.store.inventory_dictonary;

    if (this.dive.length === 0) {

      var xx = this.store.current_players.reduce((acc, c) => {
        if (!acc.find(a => a === c))
          acc.push(c);
        return acc;
      }, <string[]>[]).map(x => {
        return {
          player: this.store.players.find(p => p.name === x),
          expanded: false
        }
      }).filter(f => f);

      if (xx.length === this.store.current_players.length) {
        this.dive = <any>xx;
      }
    }
  }

  @ViewChild('childModal', { static: false }) childModal?: ModalDirective;

  showChildModal(): void {
    this.childModal?.show();
  }

  hideChildModal(): void {
    this.childModal?.hide();
  }

  Reset() {
    this.store.players = [];
    this.store.inventory = [];
    this.store.output = '';
    this.Save();
  }


  Save() {
    this.store.Save();

  }


  diving = false;

  currentRoom = 1;

  Dive() {

    if (this.dive.length == 0) {
      this.store.players.forEach(p => this.AddToDive(p));
    }

    this.Sleep();
    this.diving = true;
    this.currentRoom = 0;

    this.store.output = 'party has entered the dungeon'

    setTimeout(() => {
      this.NextRoom();
    }, 1000);

  }


  Sleep() {
    this.store.players.forEach(element => {
      element.health = element.health_max;
      element.energy = element.energy_max;
    });
    this.store.output = '';
  }



  IncrementInventory(name: string, tier: number) {
    var existing = this.store.inventory.find(x => x.name === name);
    if (existing)
      existing.quantity++;
    else
      this.store.inventory.push({ name: name, tier: tier, quantity: 1 });
  }

  SelectLootPool(): loot_pools {
    var max = this.store.loot_pool_weight.reduce((a, b) => a + b.weight, 0)
    var rand = Math.floor(Math.random() * max);

    var temp = 0;
    for (var x = 0; x < this.store.loot_pool_weight.length; x++) {
      var next = this.store.loot_pool_weight[x];
      temp += next.weight;
      if (rand <= temp)
        return next.id;

    }

    return this.store.loot_pool_weight[0].id;
  }

  SelectLoot(pool: loot_pools): InventoryItem {
    var avail = this.store.items.filter(x => x.loot === pool);
    return avail[Math.floor(Math.random() * avail.length)];
  }

  NextRoom() {
    this.currentRoom++;

    if (this.dive.length == 0) {
      this.diving = false;
      return;
    }

    var monsters = this.store.monsters.map(m => {
      return m.prefixes.filter(p => p.level === this.store.level).map(x => {
        return {
          ...x,
          ... {
            name: x.name + ' ' + m.name
          }
        }
      })
    }).filter(m => m.length > 0).reduce((a, b) => a.concat(b), []);

    var monsterTemp = monsters[Math.floor(Math.random() * monsters.length)];


    var modifier = Math.ceil(this.currentRoom / 2.0);// * (this.store.level * this.store.level);

    var monster = {
      name: monsterTemp.name,
      attributes: {
        attack: (monsterTemp.attributes.attack || 0) * modifier,
        defense: (monsterTemp.attributes.defense || 0) * modifier,
        vitality: (monsterTemp.attributes.vitality || 0) * modifier,
        stamina: (monsterTemp.attributes.stamina || 0) * modifier,
      }
    }


    var details = `party has entered room #${this.currentRoom}\n`;

    {
      const isTrap = Math.random() <= 0.4;
      /*  if (isTrap) {
  
          const player = this.dive[Math.floor(Math.random() * this.dive.length)].player;
          var trap = this.store.traps[Math.floor(Math.random() * this.store.traps.length)];
          var attributes =
          {
            attack: (trap.attributes.attack || 0) * this.store.level + 1,
            defense: (trap.attributes.defense || 0) * this.store.level + 1,
            vitality: (trap.attributes.vitality || 0),
            stamina: (trap.attributes.stamina || 0)
          }
  
          const playerAttack = this.TotalPlayerAttack(player);
          const playerDefense = this.TotalPlayerDefense(player);
  
          details += `a ${trap.name} trap is in the room (a:${attributes.attack}, d:${attributes.defense})\n`
  
          if (playerAttack > attributes.defense && playerDefense > attributes.attack) {
            details += `a ${trap.name} trap was easily bypassed\n`
          }
          else if (playerAttack > attributes.defense) {
            details += `a ${trap.name} trap was disarmed\n`
            player.energy -= this.store.level;
            player.exp += this.store.level;
          }
          else if (attributes.attack >= playerDefense) {
            var damage = attributes.attack - playerDefense
            if (player.health > damage) {
              details += `a ${trap.name} trap struck ${player.name} for ${damage} damage\n`
              player.health--;
            }
            else {
              details += `a ${trap.name} trap killed ${player.name} \n`
              player.health = 0;
              this.Death(player);
            }
          }
          else {
            details += `${player.name} managed to get by the ${trap.name}\n`
            player.energy -= (this.store.level * 2);
          }
  
  
        }
        else {*/

      details += `a ${monster.name} is in the room (a:${monster.attributes.attack}, d:${monster.attributes.defense}, v:${monster.attributes.vitality}, s:${monster.attributes.stamina})\n`


      var results = this.Battle(monster);
      details += results.details;

      if (results.won) {

        for (let i = 0; i < this.store.level; i++) {
          var reward = this.SelectLoot(this.SelectLootPool())
          this.IncrementInventory(reward.name, 1);
          details += reward.name + ' collected\n'
        }

        if (Math.random() <= 0.1) {
          details += "Experience Crystal harvested\n"
          this.IncrementInventory('Experience Crystal', this.store.level);
        }

        if (Math.random() <= 0.05) {
          details += "Class Crystal\n"
          this.IncrementInventory('Class Crystal', this.store.level);
        }

        if (this.currentRoom % 10 === 0) {
          var reward = this.SelectLoot(loot_pools.Crystal)
          details += reward.name + ' collected\n'
          this.IncrementInventory(reward.name, 1);
        }
      }
      else {
        this.diving = false;
      }

      this.store.UpdateStats();
      this.Save();

      if (this.currentRoom < this.store.rooms && this.diving) {
        setTimeout(() => {
          this.NextRoom();
        }, 2000);
      }
      else {
        this.diving = false;
      }
    }

    this.AppendMessage(details);
  }

  AppendMessage(msg: string) {
    this.store.output = msg + '\n\n' + this.store.output
  }

  TotalPlayerAttack(player: Player) {
    return (player.attributes.attack || 0) + (player.equipment_attributes.attack || 0) +
      Math.ceil((this.dive.filter(p => p.player !== player && player.attributes).reduce((a, c) => a + c.player.attributes.attack, 0) / 2.0))
  }


  TotalPlayerDefense(player: Player) {
    return (player.attributes.defense || 0) + (player.equipment_attributes.defense || 0) +
      Math.ceil((this.dive.filter(p => p.player !== player && player.attributes).reduce((a, c) => a + c.player.attributes.defense, 0) / 2.0))
  }


  Battle(monster: {
    name: string,
    attributes: Required<AttributeStore>
  }): { details: string, won: boolean } {
    var details = '';
    var monsterHealth = Math.max(1, monster.attributes.vitality * 10);
    var won = false;


    while (monsterHealth > 0 && this.dive.length > 0) {
      var playerIndex = Math.floor(Math.random() * this.dive.length)

      const player = this.dive[playerIndex].player;

      const playerAttack = this.TotalPlayerAttack(player);
      const playerDefense = this.TotalPlayerDefense(player);

      if (this.currentRoom === 3) {
        if (playerAttack <= monster.attributes.defense && playerDefense <= monster.attributes.attack) {
          details += `-${player.name} ran in fear\n`;
          this.dive = this.dive.filter(x => x.player !== player);
          continue;
        }
      }


      if (player.energy >= this.store.level) {
        player.energy -= this.store.level;

        if (playerAttack > monster.attributes.defense) {
          var damage = playerAttack - monster.attributes.defense;
          if (monsterHealth > damage) {
            monsterHealth -= damage;
            details += `${player.name} did ${damage} damage\n`
            player.exp += damage;
          }
          else {
            details += `-${player.name} killed the ${monster.name}\n`
            monsterHealth = 0;
            player.exp += monsterHealth;
            won = true;
          }
        }
        else {
          details += `${player.name} did no damage\n`
        }
      }
      else {
        details += `-${player.name} left in exashtion\n`;
        this.dive = this.dive.filter(x => x.player !== player);
      }

      if (monsterHealth > 0) {
        if (monster.attributes.attack > playerDefense) {
          var damage = (monster.attributes.attack - playerDefense);
          player.health -= damage;
          details += `${monster.name} did ${damage} damage\n`

          if (player.health <= 1) {
            this.dive = this.dive.filter(x => x.player !== player);
            details += `-${player.name} ran from the fight\n`
            continue;
          }

          if (player.health <= 0) {
            details += `-${monster.name} killed ${player.name}\n`
            this.Death(player);
            break;
          }
        }
        else {
          details += `${monster.name} did no damage\n`
        }
      }
    }

    return { details: details, won: won };
  }



}
